const compararPorCampo = (a, b, campo, direccion) => {
  if (a[campo] < b[campo]) {
    return direccion === 'ASC' ? -1 : 1
  }

  if (a[campo] > b[campo]) {
    return direccion === 'ASC' ? 1 : -1
  }

  return 0
}

export const aplicarOrdenamiento = (publicaciones, criterio = {}) => {
  const orden = criterio?.orden || 'DESC'
  const campo = criterio?.campo || 'idPublicacion'
  const ventasPorVendedor = {}

  publicaciones.forEach((pub) => {
    if (!ventasPorVendedor[pub.idVendedor]) {
      ventasPorVendedor[pub.idVendedor] = 0
    }
    ventasPorVendedor[pub.idVendedor] += pub.totalItemsPedidos || 0
  })

  return [...publicaciones].sort((a, b) => {
    const comparacionPrincipal = compararPorCampo(a, b, campo, orden)
    if (comparacionPrincipal !== 0) {
      return comparacionPrincipal
    }

    if (a.idPublicacionExposicion !== b.idPublicacionExposicion) {
      return a.idPublicacionExposicion - b.idPublicacionExposicion
    }

    const ventasProductoA = a.totalItemsPedidos || 0
    const ventasProductoB = b.totalItemsPedidos || 0
    if (ventasProductoA !== ventasProductoB) {
      return ventasProductoB - ventasProductoA
    }

    const ventasVendedorA = ventasPorVendedor[a.idVendedor] || 0
    const ventasVendedorB = ventasPorVendedor[b.idVendedor] || 0

    return ventasVendedorB - ventasVendedorA
  })
}
